import { isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { ProductVariationType } from "@faire/web-api--source/indigofair/data/ProductVariationType";
import pick from "lodash/pick";
import sortBy from "lodash/sortBy";
export var isSizeVariation = function(variationType) {
    return variationType === ProductVariationType.SIZE;
};
/**
 * Convert a variation object into a string key that we can use to index
 * a map of options that may be organized into prepacks.
 */ export var getStyleKeyFromVariations = function(variations) {
    var sortedAndFilteredVariations = // Sort the variations so that the same variations in different orders still
    // produce the same key
    sortBy(variations, function(v) {
        return v.name;
    })// Remove size variations, as they're not relevant to a "style"
    .filter(function(variation) {
        return !isSizeVariation(variation.type);
    })// MobX sometimes adds additional properties to our objects, make sure we're
    // only serializing the properties we care about
    .map(function(v) {
        return pick(v, [
            "name",
            "value"
        ]);
    });
    return JSON.stringify(sortedAndFilteredVariations);
};
export var getCurrentStyleHasOnlyPrePacks = function(optionsByStyle, selectedOption) {
    var currentStylesOptions = optionsByStyle[getStyleKeyFromVariations(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.variations)] || [];
    return currentStylesOptions.length > 0 && currentStylesOptions.every(function(option) {
        return isPrePackProductOption(option);
    });
};
